/**
 * @module router/guards/menuGuard
 * @description 메뉴 권한 라우트 가드 (SURINP-692) — `meta.menuYn === true` 화면은 GET /auth/menus 트리에
 * 그 경로(상세는 소속 목록 메뉴)가 있어야 들어갈 수 있습니다. 판정은 menuStore.canAccessPath 하나를 씁니다.
 * 미충족 시 안내 후 /dashboard 로 리다이렉트합니다. 서버 측 차단(403)은 SURINP-696 몫입니다.
 * roleGuard 통과 이후에 호출되어야 합니다(비로그인은 authGuard 가 먼저 /login 으로 보낸다).
 */
import i18n from '@/locales/i18n'
import { useMenuStore } from '@/stores/menu'

/**
 * 메뉴 권한 검사. 메뉴 트리가 아직 없거나 다른 계정 것이면 로드를 기다린 뒤 판정합니다.
 *
 * @param {import('vue-router').RouteLocationNormalized} to - 이동할 라우트
 * @param {import('vue-router').RouteLocationNormalized} from - 현재 라우트
 * @param {import('vue-router').NavigationGuardNext} next - 다음 라우트 진행 함수
 * @returns {Promise<boolean>} 리다이렉트가 발생한 경우 true, 통과한 경우 false
 */
export const menuGuard = async (to, from, next) => {
  if (!to.meta || to.meta.menuYn !== true) return false
  const menuStore = useMenuStore()
  if (menuStore.canAccessPath(to.path)) return false
  // 미로드(새로고침 첫 진입)·다른 계정의 트리면 다시 불러온 뒤 판정한다 — 같은 계정으로 로드돼 있으면 no-op
  await menuStore.loadMenu()
  if (menuStore.canAccessPath(to.path)) return false
  window.appAlert(i18n.global.t('message.noMenuPermission'), 'warning')
  next({ path: '/dashboard' })
  return true
}
